try{
    let workDelivery = document.querySelector(".work-delivery"),
        workCustoms = document.querySelector(".work-customs"),
        schemeWorkDelivery = document.querySelector(".scheme-work__delivery"),
        schemeWorkCustoms = document.querySelector(".scheme-work__customs"),
        schemeWorkNavButtons = document.querySelectorAll(".scheme-work__nav button");


    schemeWorkNavButtons.forEach((item) => {
        //console.log(item.getAttribute("data-attr"));

        item.addEventListener("click", (e) => {
            e.preventDefault();
            workDelivery.classList.remove("show");
            workCustoms.classList.remove("show");
            schemeWorkDelivery.classList.remove("show");
            schemeWorkCustoms.classList.remove("show");
            workDelivery.classList.add("hide");
            workCustoms.classList.add("hide");
            schemeWorkDelivery.classList.add("hide");
            schemeWorkCustoms.classList.add("hide");


            if(document.querySelector(`.work-${item.getAttribute("data-attr")}`).classList.contains("hide")){
                document.querySelector(`.work-${item.getAttribute("data-attr")}`).classList.remove("hide");
                document.querySelector(`.work-${item.getAttribute("data-attr")}`).classList.add("show");
            }

            if(document.querySelector(`.scheme-work__${item.getAttribute("data-attr")}`).classList.contains("hide")){
                document.querySelector(`.scheme-work__${item.getAttribute("data-attr")}`).classList.remove("hide");
                document.querySelector(`.scheme-work__${item.getAttribute("data-attr")}`).classList.add("show");
            }


        })
    })

}catch(e){
    //console.log(e);
}

try {

    window.addEventListener('scroll', function () {
        let scrollTop = window.pageYOffset;

        if (scrollTop >= 50) {
            document.querySelector('#header').classList.add('scroll');
        } else {
            document.querySelector('#header').classList.remove('scroll');
        }


    });


} catch(e) {
    //console.log(e);
}


try {
    let animateNumber = document.querySelectorAll(".animate-number"),
    positionBlockCounters = document.querySelector(".advantage__counters").getBoundingClientRect().top;

    animateNumber.forEach((item) => {
        window.addEventListener('scroll', function onScroll() {
            console.log(window.pageYOffset);
           if ( window.pageYOffset > (positionBlockCounters - window.innerHeight/2)){

               this.removeEventListener('scroll', onScroll);
               let interval = setInterval(function () {
                   item.innerHTML = ++item.innerHTML;
                   if(item.innerHTML == item.getAttribute("data-max")){
                       clearInterval(interval);
                   }
               }, 5);
           }

        });
    })

} catch (e){
    //console.log(e);
}


try {
    const anchors = document.querySelectorAll(".anchors");
    anchors.forEach((item) => {
        item.addEventListener('click', function (e) {
            e.preventDefault();
            const blockID = item.getAttribute('href').substr(1);
            document.getElementById(blockID).scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
            anchors.forEach((i) => {
                i.classList.remove("active");
            });
            item.classList.add("active");
        })
    });
}catch(e){
    //console.log(e);
}